import {
  SET_ACTUAL_STATUS,
  PUSH_ACTUAL_STATUS,
  SET_BEACON_STATUS,
  PUSH_BEACON_STATUS,
  SET_UNREAD_NOTIFICATIONS_COUNT,
  SET_CURRENT_ACCOUNT_DATA
} from 'contexts/actions/actionTypes';
import unionBy from 'lodash/unionBy';
export default (state, action) => {
  switch (action.type) {
    case SET_BEACON_STATUS:
      return {
        ...state,
        beaconStatus: action.payload
      };
    case PUSH_BEACON_STATUS:
      return {
        ...state,
        beaconStatus: unionBy(action.payload, state.beaconStatus, 'networkId')
      };
    case 'PUSH_BEACON_STATUS2':
      return {
        ...state,
        beaconStatus: unionBy(action.payload, state.beaconStatus, 'id')
      };
    case SET_ACTUAL_STATUS:
      return {
        ...state,
        actualStatus: action.payload
      };
    case PUSH_ACTUAL_STATUS:
      return {
        ...state,
        actualStatus: unionBy(action.payload, state.actualStatus, 'id')
      };
    case SET_UNREAD_NOTIFICATIONS_COUNT:
      return {
        ...state,
        unreadNotificationsCount: action.payload
      };
    case SET_CURRENT_ACCOUNT_DATA:
      return {
        ...state,
        customerData: action.payload
      };

    default:
      return state;
  }
};
